import React, { createContext } from 'react';

export const Theme = createContext(null);